module.exports = __webpack_public_path__ + "img/job-search.2f903567.jpg";